import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

// Attach token from localStorage as a fallback (cross-domain cookies may be blocked)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ff2d_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Safety net: FastAPI validation (422) returns `detail` as an array of objects.
// Many components do `setErr(e.response.data.detail)` and render it directly,
// which crashes React ("Objects are not valid as a React child") → blank screen.
// Normalize detail to a string here so no caller can ever trigger that crash.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const d = error?.response?.data;
    if (d && d.detail != null && typeof d.detail !== "string") {
      d.detail = formatApiError(d.detail);
    }
    return Promise.reject(error);
  }
);

export default api;
